import { createReduxAction } from '@store';
import { APP_RESET_STORE } from '@actions/action-types';

import { AppResetStore } from './types';

export const appResetStore = (): AppResetStore =>
  createReduxAction(APP_RESET_STORE);
